import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendBankTransfer = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 176,
	height: 176,
	viewBox: "0 0 176 176",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_4173_30219)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 88,
				cy: 88,
				r: 63,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.075 70.15L88.166 65.396L111.257 70.15V74.2249H65.075V70.15Z",
			fill: "#FFCE32"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 68.4939,
			y: 74.2246,
			width: 5.62053,
			height: 27.1659,
			fill: "#FFCE32"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 68.4939,
			y: 79.6582,
			width: 5.62053,
			height: 2.71659,
			fill: "#F09337"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 102.219,
			y: 74.2246,
			width: 5.62053,
			height: 27.1659,
			fill: "#FFCE32"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 102.219,
			y: 79.6582,
			width: 5.62053,
			height: 2.71659,
			fill: "#F09337"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 85.355,
			y: 74.2246,
			width: 5.62053,
			height: 27.1659,
			fill: "#FFCE32"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 85.355,
			y: 79.6582,
			width: 5.62053,
			height: 2.71659,
			fill: "#F09337"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 63.7166,
			y: 97.3154,
			width: 48.8986,
			height: 4.07488,
			fill: "#FFCE32"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 61,
			y: 104.091,
			width: 54.3318,
			height: 4.07488,
			fill: "#FFCE32"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 65.075,
			y: 74.2246,
			width: 46.182,
			height: 5.43318,
			fill: "#F09337"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 88.1659,
			cy: 70.1498,
			r: 8.14977,
			fill: "#FFCE32"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.6373 74.6229C87.5662 74.6229 87.5057 74.598 87.456 74.5482C87.4062 74.4984 87.3813 74.438 87.3813 74.3668V73.6199C86.8549 73.5701 86.4103 73.4456 86.0475 73.2465C85.6847 73.0402 85.4108 72.7948 85.2259 72.5102C85.0409 72.2186 84.9413 71.9162 84.9271 71.6032C84.9271 71.5392 84.9484 71.4859 84.9911 71.4432C85.0409 71.4005 85.0978 71.3792 85.1618 71.3792H86.1115C86.1969 71.3792 86.2644 71.4005 86.3142 71.4432C86.364 71.4788 86.4032 71.525 86.4316 71.5819C86.4814 71.7171 86.5632 71.8522 86.677 71.9874C86.798 72.1154 86.9651 72.2221 87.1785 72.3075C87.3919 72.3928 87.6587 72.4355 87.9788 72.4355C88.491 72.4355 88.8715 72.3502 89.1205 72.1794C89.3695 72.0087 89.494 71.7775 89.494 71.4859C89.494 71.2796 89.4264 71.116 89.2912 70.995C89.1632 70.867 88.9569 70.7532 88.6724 70.6536C88.3878 70.5469 88.0144 70.4366 87.552 70.3228C87.0256 70.1948 86.581 70.0418 86.2182 69.864C85.8554 69.679 85.5815 69.4479 85.3966 69.1704C85.2188 68.893 85.1298 68.5409 85.1298 68.1141C85.1298 67.5663 85.329 67.1004 85.7274 66.7163C86.1257 66.3321 86.677 66.0974 87.3813 66.012V65.2758C87.3813 65.2046 87.4062 65.1442 87.456 65.0944C87.5057 65.0446 87.5662 65.0197 87.6373 65.0197H88.2882C88.3594 65.0197 88.4198 65.0446 88.4696 65.0944C88.5194 65.1442 88.5443 65.2046 88.5443 65.2758V66.0334C89.028 66.1045 89.4335 66.2468 89.7607 66.4602C90.088 66.6736 90.3369 66.919 90.5077 67.1964C90.6784 67.4667 90.7673 67.7299 90.7744 67.986C90.7744 68.0429 90.7531 68.0963 90.7104 68.1461C90.6748 68.1888 90.6215 68.2101 90.5503 68.2101H89.558C89.494 68.2101 89.4335 68.1959 89.3766 68.1674C89.3197 68.139 89.2735 68.0856 89.2379 68.0074C89.2023 67.7868 89.0672 67.5983 88.8324 67.4418C88.5977 67.2853 88.2918 67.2071 87.9148 67.2071C87.5306 67.2071 87.2212 67.2782 86.9865 67.4205C86.7588 67.5628 86.645 67.7833 86.645 68.0821C86.645 68.2812 86.7019 68.4484 86.8157 68.5836C86.9296 68.7116 87.1145 68.8254 87.3706 68.925C87.6338 69.0246 87.9824 69.1313 88.4163 69.2451C89.0209 69.3803 89.5118 69.5368 89.8888 69.7146C90.2729 69.8924 90.5539 70.1201 90.7317 70.3975C90.9167 70.6678 91.0092 71.0128 91.0092 71.4325C91.0092 71.8451 90.906 72.2079 90.6997 72.5209C90.5005 72.8268 90.216 73.0757 89.8461 73.2678C89.4762 73.4528 89.0423 73.5737 88.5443 73.6306V74.3668C88.5443 74.438 88.5194 74.4984 88.4696 74.5482C88.4198 74.598 88.3594 74.6229 88.2882 74.6229H87.6373Z",
			fill: "#1E63FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52 103.4H124",
			stroke: "#1E63FF",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_4173_30219",
			x: 0,
			y: 0,
			width: 176,
			height: 176,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.18 0 0 0 0 0.206667 0 0 0 0 0.22 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_4173_30219"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_4173_30219",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgSendBankTransfer;
